import React from "react";

// Claves of the contract partidas (PartidaContrato) linked to the partida.
export const getClavesPartida = (partida) =>
  Array.isArray(partida?.claves) ? partida.claves.filter(Boolean) : [];

export const renderNombrePartida = (partida) => {
  const claves = getClavesPartida(partida);
  return (
    <>
      {claves.length > 0 && <span>[{claves.join(", ")}] </span>}
      {partida?.nombre}
    </>
  );
};

// A partida is highlighted as aditiva when it or any of its destajos /
// subdestajos has avance over 100%.
export const partidaTieneAditivos = (partida, destajos, subdestajos) => {
  if (!partida) return false;
  if (parseFloat(partida.real) > 1) return true;
  const destajosPartida = (Array.isArray(destajos) ? destajos : []).filter(
    (destajo) => destajo.idPartida === partida.idPartida
  );
  if (destajosPartida.some((destajo) => parseFloat(destajo.progreso) > 1)) {
    return true;
  }
  const idsDestajos = new Set(destajosPartida.map(({ idDestajo }) => idDestajo));
  return (Array.isArray(subdestajos) ? subdestajos : []).some(
    (subdestajo) =>
      idsDestajos.has(subdestajo.idDestajo) &&
      parseFloat(subdestajo.progreso) > 100
  );
};
